import { koComponent } from '../../../../ko-utils';
import { UAParser } from 'ua-parser-js';
import languages from '../../../../utils/languages';
import { getSomeName } from '../../utils';

class DetailsView {
    constructor(params) {
        const data = ko.unwrap(params.data);

        this.feedback = data;

        this.isNative = this.feedback.isNative ? this.feedback.isNative() : false;

        this.parentClose = params.onClose;
        this.parentResolve = params.onSolve;
        this.parentUnsolve = params.onUnsolve;

        this.screenshots = data.screenshots;
        this.videos = data.videos;

        this.envInfo = {};
        try {
            const ev = ko.unwrap(data.environmentInfo);
            this.envInfo = JSON.parse(ev);
        } catch {
        }

        this.authorUsername = data.authorUsername();
        this.authorProps = data.authorProps();

        this.customPropsPretty = this.authorProps ? JSON.stringify(JSON.parse(this.authorProps), null, 2) : '';

        this.selectedType = ko.observable();
        this.selectedId = ko.observable();

        this.attachedContent = ko.pureComputed(() => {
            const mapper = (type) => (item) => {
                return {
                    id: item,
                    type: type
                };
            };

            return [...this.screenshots().map(mapper('screenshot')), ...this.videos().map(mapper(!this.isNative ? 'video' : 'video_native'))];
        });

        const firstItem = this.attachedContent()[0];

        if (firstItem) {
            this.selectItem(firstItem.id, firstItem.type);
        }

        this.browserInfo = UAParser(this.envInfo.userAgent);

        this.getSomeName = getSomeName;
    }

    solve() {
        this.parentResolve(this.feedback)

        // probably enhance this with callback from the above method
        this.feedback.isSolved(true);
    }

    unsolve() {
        this.parentUnsolve(this.feedback)

        // probably enhance this with callback from the above method
        this.feedback.isSolved(false);
    }

    getLanguage(lng) {
        const sanitized = lng.substr(0, 2).toLowerCase();

        const foundLng = languages.filter(l => l.alpha2 == sanitized)[0];

        return foundLng ? foundLng.English : lng;
    }

    getIconByBrowser(browserName) {
        switch (browserName.toLowerCase()) {
            case 'chrome': return 'fab fa-chrome';
            case 'firefox': return 'fab fa-firefox';
            case 'safari': return 'fab fa-safari';
            case 'ie': return 'fab fa-internet-explorer';
            case 'edge': return 'fab fa-edge';
            default: return 'far fa-window-maximize';
        }
    }

    getIconByOs(osName) {
        const osIcons = {
            'android': 'fab fa-android',
            'windows': 'fab fa-windows',
            'mac os': 'fab fa-apple',
            'linux': 'fab fa-linux',
        }

        for (const osKey of Object.keys(osIcons)) {
            if (osName.toLowerCase().startsWith(osKey)) {
                return osIcons[osKey];
            }
        }

        return 'fas fa-microchip';
    }

    getDeviceByViewport(width) {
        if (width > 768) {
            return 'fas fa-desktop';
        } else {
            return 'fas fa-mobile-alt';
        }
    }

    selectItem(id, type) {
        this.selectedType(type);
        this.selectedId(id);

        if (type == 'video' || type == 'video_native') {
            this.selectVideo(id);
        }
    }

    async selectVideo(videoFileId) {
        if (!this.isNative) {
            let resp = await fetch('/files/' + videoFileId + '/data');

            let tarEl = document.getElementsByClassName('video-holder')[0];
            let bounds = tarEl.getBoundingClientRect();

            tarEl.innerHTML = '';

            new PF_rrwebPlayer({
                target: tarEl, // customizable root element
                data: {
                    events: JSON.parse(pako.inflate(await resp.text(), { to: 'string' })),
                    autoPlay: true,
                    width: bounds.width,
                    height: bounds.height - 120,
                    UNSAFE_replayCanvas: true
                }
            });
        } else {
            document.querySelectorAll('video').forEach(vidEl => {
                vidEl.onloadedmetadata = function () {
                    // handle chrome's bug
                    if (vidEl.duration === Infinity) {
                        // set it to bigger than the actual duration
                        vidEl.currentTime = 1e101;
                        vidEl.ontimeupdate = function () {
                            this.ontimeupdate = () => {
                                return;
                            }
                            vidEl.currentTime = 0;
                        }
                    }
                }
            });
        }
    }

    closeItself() {
        this.parentClose();
    }
}

export default koComponent('feedback-details-view', DetailsView);